import Text from "components/Text";
import { Row } from "components/Layout/Grid";
import { Column } from "components/Layout/Grid";
import React from "react";
import { Bar, ResponsiveContainer } from "recharts";
import { BarChart } from "recharts";
import { XAxis } from "recharts";
import { YAxis } from "recharts";
import { Tooltip } from "recharts";
import SelectableButton from "../generics/SelectableButton";
import "./style.scss";

export type PeriodOption = 0 | 3;

interface ManagementBarChartProps {
  data?: any;
  selectedPeriod: PeriodOption;
  onPeriodChange: (period: PeriodOption) => void;
}

export const ManagementBarChart: React.FC<ManagementBarChartProps> = ({
  data,
  selectedPeriod,
  onPeriodChange,
}) => (
    <>
      <Row
        className="pt-md-0 flex-lg-column bg-white radius-10"
        style={{ borderRadius: "10px", margin: "0.4rem" }}
      >
        <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
          <Row className="pt-md-0 flex-lg-column mb-4 mt-4 ml-3">
            <Column className="w-100 w-lg-100">
              <Row className="d-flex gap-2">
                <Text size={24} width={"22rem"} className="font-bold color-primary">
                  Evolução temporal - Taxas
                </Text>
                <Row className="d-flex gap-2 w-100 w-lg-100" style={{justifyContent: 'space-between'}}>
                  <div>
                    <SelectableButton
                      label="3 meses"
                      selected={selectedPeriod === 0}
                      onClick={() => onPeriodChange(0)}
                    />
                    <SelectableButton
                      label="6 meses"
                      selected={selectedPeriod === 3}
                      onClick={() => onPeriodChange(3)}
                    />
                  </div>
                  <div className="legend-container">
                    <div className="legend-item">
                      <div className="legend-item-box1"></div>
                      <label>Taxa de Revisão (%)</label>
                    </div>
                    <div className="legend-item">
                      <div className="legend-item-box2"></div>
                      <label>Taxa de Alteração (%)</label>
                    </div>
                  </div>
                </Row>
              </Row>
            </Column>
          </Row>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
                cursor={{ fill: "rgba(40, 124, 135, 0.1)" }}
              />
              <Bar
                dataKey="reviewRate"
                name="Taxa de Revisão (%)"
                fill="#287C87"
                radius={[10, 10, 0, 0]}
                activeBar={{
                  fill: "#1a5a62",
                  stroke: "#287C87",
                  strokeWidth: 2,
                }}
              />
              <Bar
                dataKey="changeRate"
                name="Taxa de Alteração (%)"
                fill="#6EE4D9"
                radius={[10, 10, 0, 0]}
                activeBar={{
                  fill: "#4dc4b9",
                  stroke: "#6EE4D9",
                  strokeWidth: 2,
                }}
              />
            </BarChart>
          </ResponsiveContainer>
        </Column>
      </Row>
    </>
  );
